document.addEventListener('DOMContentLoaded', function () {

  /* =========================================
     BRA SIZE MAP
  ========================================= */

  const braSizeMap = {
  "32": {
    "A": "S",
    "B": "S",
    "C": "M",
    "D": "M",
    "DD": "L"
  },

  "34": {
    "A": "M",
    "B": "L",
    "C": "L",
    "D": "XL",
    "DD": "XL"
  },

  "36": {
    "A": "L",
    "B": "L",
    "C": "XL",
    "D": "XL",
    "DD": "XXL"
  },

  "38": {
    "A": "XL",
    "B": "XL",
    "C": "XXL",
    "D": "XXL",
    "DD": "XXXL"
  },

  "40": {
    "A": "XXL",
    "B": "XXL",
    "C": "XXXL",
    "D": "XXXL",
    "DD": "4XL"
  },

  "42": {
    "A": "XXL",
    "B": "XXXL",
    "C": "XXXL",
    "D": "4XL",
    "DD": "4XL"
  },

  "44": {
    "A": "XXXL",
    "B": "XXXL",
    "C": "4XL",
    "D": "4XL",
    "DD": "4XL"
  }
};


  /* =========================================
     ELEMENTS
  ========================================= */

  const quizOverlay = document.getElementById('braQuizOverlay');
  const openBtn = document.getElementById('braQuizOpen');
  const closeBtn = document.getElementById('braQuizClose');
  const counter = document.getElementById('braStepCounter');
  const progressBars = document.querySelectorAll('.bra-progress-bar');
  const steps = document.querySelectorAll('.bra-step');
  const restartBtn = document.getElementById('braRestart');

  if (!quizOverlay || !openBtn) {
    console.log('Bra quiz not found on this page.');
    return;
  }


  let selectedBand = null;
  let selectedCup = null;
  let currentStep = 1;


  /* =========================================
     GET SHOPIFY SIZE CHART
  ========================================= */

  function getShopifySizeChart() {

    /*
     Find the Shopify drawer containing
     our Find My Size button.
    */

    return openBtn.closest('x-modal');

  }


  /* =========================================
     CLOSE SHOPIFY SIZE CHART
  ========================================= */

  function closeShopifySizeChart() {

    const sizeChart = getShopifySizeChart();

    if (!sizeChart) {
      console.log('Shopify size chart drawer not found.');
      return;
    }

    const closeButton =
      sizeChart.querySelector('.drawer__close');

    if (closeButton) {

      console.log('Closing Shopify size chart');

      closeButton.click();

      return;
    }


    /*
     Fallback:
     click Shopify overlay
    */

    const shopifyOverlay =
      sizeChart.querySelector('overlay-element');

    if (shopifyOverlay) {

      console.log('Closing size chart using overlay');

      shopifyOverlay.click();

    }

  }


  /* =========================================
     OPEN SHOPIFY SIZE CHART
  ========================================= */

  function openShopifySizeChart() {

    const sizeChart = getShopifySizeChart();

    if (!sizeChart) {
      console.log('Shopify size chart drawer not found.');
      return;
    }

    const modalId = sizeChart.id;


    /*
     Your original Shopify button:

     <button
       class="link ..."
       aria-controls="SizeChart-..."
     >
       Size chart
     </button>
    */

    const sizeChartButton = document.querySelector(
      'button.link[aria-controls="' + modalId + '"]'
    );


    if (!sizeChartButton) {

      console.log('Original Shopify Size chart button not found.');

      return;

    }


    console.log('Opening Shopify size chart');

    sizeChartButton.click();

  }


  /* =========================================
     OPEN QUIZ
  ========================================= */

  openBtn.addEventListener('click', function (event) {

    event.preventDefault();
    event.stopPropagation();

    console.log('Find my size clicked');


    /*
     FIRST close Shopify drawer
    */

    closeShopifySizeChart();


    /*
     THEN open our quiz after Shopify's
     drawer animation finishes.
    */

    setTimeout(function () {

      quizOverlay.classList.add('is-open');

      document.body.style.overflow = 'hidden';

    }, 350);

  });


  /* =========================================
     CLOSE QUIZ
  ========================================= */

  function closeQuiz() {

    quizOverlay.classList.remove('is-open');

    document.body.style.overflow = '';

  }


  if (closeBtn) {

    closeBtn.addEventListener('click', function () {

      closeQuiz();

    });

  }


  quizOverlay.addEventListener('click', function (event) {

    if (event.target === quizOverlay) {

      closeQuiz();

    }

  });


  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      quizOverlay.classList.contains('is-open')
    ) {

      closeQuiz();

    }

  });


  /* =========================================
     SHOW QUIZ STEP
  ========================================= */

  function showStep(step) {

    currentStep = step;


    steps.forEach(function (item) {

      item.classList.remove('active');

    });


    const target = document.querySelector(
      '.bra-step[data-step="' + step + '"]'
    );


    if (target) {

      target.classList.add('active');

    }


    /* STEP 1 */

    if (step === 1) {

      if (counter) {
        counter.textContent = 'Question 1 of 2';
      }

      if (progressBars[0]) {
        progressBars[0].classList.add('active');
      }

      if (progressBars[1]) {
        progressBars[1].classList.remove('active');
      }

    }


    /* STEP 2 */

    if (step === 2) {

      if (counter) {
        counter.textContent = 'Question 2 of 2';
      }

      if (progressBars[0]) {
        progressBars[0].classList.add('active');
      }

      if (progressBars[1]) {
        progressBars[1].classList.add('active');
      }

    }


    /* RESULT */

   if (step === 'result') {

  if (counter) {
    counter.textContent = 'Your result';
  }

  // Hide progress bars on result
  const progress = document.querySelector('.bra-progress');

  if (progress) {
    progress.style.display = 'none';
  }

}

  }


  /* =========================================
     BAND
  ========================================= */

  document
    .querySelectorAll('[data-band]')
    .forEach(function (button) {

      button.addEventListener('click', function () {

        selectedBand = this.dataset.band;


        document
          .querySelectorAll('[data-band]')
          .forEach(function (item) {

            item.classList.remove('selected');

          });


        this.classList.add('selected');


        setTimeout(function () {

          showStep(2);

        }, 150);

      });

    });


  /* =========================================
     CUP
  ========================================= */

  document
    .querySelectorAll('[data-cup]')
    .forEach(function (button) {

      button.addEventListener('click', function () {

        selectedCup = this.dataset.cup;


        document
          .querySelectorAll('[data-cup]')
          .forEach(function (item) {

            item.classList.remove('selected');

          });


        this.classList.add('selected');


        showResult();

      });

    });


  /* =========================================
     RESULT
  ========================================= */

  function showResult() {

  let recommendedSize = null;

  if (
    braSizeMap[selectedBand] &&
    braSizeMap[selectedBand][selectedCup]
  ) {
    recommendedSize =
      braSizeMap[selectedBand][selectedCup];
  }


  const resultSize =
    document.getElementById('braRecommendedSize');


  if (resultSize) {
    resultSize.textContent =
      recommendedSize ? recommendedSize : '—';
  }


  showStep('result');
}


  /* =========================================
     BACK BETWEEN QUIZ STEPS
  ========================================= */

  document
    .querySelectorAll('[data-back]')
    .forEach(function (button) {

      button.addEventListener('click', function () {

        const step =
          parseInt(this.dataset.back, 10);

        showStep(step);

      });

    });


  /* =========================================
     SEE THE SIZE CHART

     Close quiz ->
     reopen Shopify drawer
  ========================================= */

  document
    .querySelectorAll('[data-show-chart]')
    .forEach(function (button) {

      button.addEventListener('click', function (event) {

        event.preventDefault();

        console.log('See size chart clicked');


        /* Close quiz */

        closeQuiz();


        /*
         Wait a moment, then reopen
         Shopify's original drawer.
        */

        setTimeout(function () {

          openShopifySizeChart();

        }, 150);

      });

    });


  /* =========================================
     RESTART
  ========================================= */

  if (restartBtn) {

    restartBtn.addEventListener('click', function () {

      selectedBand = null;
      selectedCup = null;


      document
        .querySelectorAll('.bra-option')
        .forEach(function (button) {

          button.classList.remove('selected');

        });


      showStep(1);

    });

  }

});